<template>
    <div :style="[conditionalStyles, styles]" class="toolTip">
        <h4 class="toolTip__title">{{ title }}</h4>
        <ul class="toolTip__list" v-if="list">
            <li class="toolTip__item" v-for="(item, idx) in list" :key="idx">{{ item }}</li>
        </ul>
        <span v-else class="toolTip__message">{{ message }}</span>
    </div>
</template>

<script>
import { reactive } from 'vue';

export default {
    props: ['title', 'message', 'list', 'color', 'styles'],
    setup(props) {
        const conditionalStyles = reactive({
            color: props.color
        })

        return {
            conditionalStyles
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
.toolTip{
    background-color: $lightgreen;
    max-width: 200px;
    padding: 18px 12px;
    border-radius: 10px;
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 2px;
    z-index: 9999;
    &__title{
        font-weight: 700;
        font-size: 12px;
    }
    &__message{
        font-weight: 400;
        font-size: 11px;
        text-wrap: wrap;
    }
    &__list{
        li{
            font-weight: 400;
            font-size: 11px;
        }
    }
}
</style>